import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withHandlers,
  lifecycle,
  withState
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ReactSelectMaterialUi from 'react-select-material-ui';
import GochiChildFoodListDetailTableShop from '../../components/molecules/GochiChildFoodListDetailTableShop';
import CloseButton from '../../components/atoms/CloseButton';
import { languages, languageType } from '../../constants/Language';

const styles = {
  root: {
    // position: 'absolute',
    width: '100%',
    height: 'auto',
    maxHeight: '100%',
    top: '5%',
    // left: '2%',
    backgroundColor: '#fff',
    padding: 10,
    overflow: 'auto',
    outline: 'none',
    borderRadius: 4,
    paddingBottom: 10
  },
  margin: {
    margin: '20px 0 0 0'
  },
  scrollTable: {
    maxHeight: 296,
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  },
  titleDetail: {
    fontSize: 20,
    fontWeight: 'bold',
    padding: '5px 0 10px'
  },
  btnClose: {
    fontSize: 14,
    fontWeight: 'bold'
  },
  selectControl: {
    width: '100%'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};
const enhance = compose(
  connect(dispatch => ({
    actions: bindActionCreators({}, dispatch)
  })),
  setPropTypes(propTypes),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  withHandlers({}),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({ classes, detail, updateOpenDetailModal, isLanguage, setIsLanguage }) => {
    const closeAction = () => updateOpenDetailModal(false);
    let { childFoodName, childFoodDescription } = detail;

    if (isLanguage !== languageType.ORIGIN) {
      const languageData = detail.otherLanguages.find(
        language => language.language === isLanguage
      );
      if (languageData)
        ({ childFoodName, childFoodDescription } = languageData.params);
    }
    return (
      <div className={classes.root}>
        <Typography variant="h6" className={classes.titleDetail}>
          こども食堂メニュー情報詳細
        </Typography>
        <div>
          <ReactSelectMaterialUi
            required
            className={[classes.textField, classes.selectControl]}
            defaultValue={isLanguage}
            value={isLanguage}
            options={languages}
            margin="normal"
            onChange={v => {
              if (isLanguage === v) {
                return;
              }
              setIsLanguage(v);
            }}
          />
          <GochiChildFoodListDetailTableShop
            groupName={detail.groupName}
            childFoodName={childFoodName}
            childFoodId={detail.childFoodId}
            shopName={detail.shopName}
            menuChild={detail.menuChild}
            childFoodDescription={childFoodDescription}
            childFoodImage={detail.childFoodImage}
            createdAt={detail.createdAt}
            updatedAt={detail.updatedAt}
          />
        </div>
        <div>
          <CloseButton
            className={classes.btnClose}
            onClickAction={closeAction}
          />
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
